module.exports = __webpack_public_path__ + "img/1.25bda6f8.jpg";